import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "../utils/auth";

const UnprotectedRoute: React.FC = () => {
  const locationTo = "/admin";

  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    return !!getToken();
  });

  useEffect(() => {
    const syncAuth = () => {
      const tokenExists = !!getToken();
      setIsAuthenticated((prev) => (prev !== tokenExists ? tokenExists : prev));
    };

    const intervalCheck = setInterval(syncAuth, 1000);
    window.addEventListener("visibilitychange", syncAuth);
    window.addEventListener("focus", syncAuth);

    return () => {
      clearInterval(intervalCheck);
      window.removeEventListener("visibilitychange", syncAuth);
      window.removeEventListener("focus", syncAuth);
    };
  }, []);

  return !isAuthenticated ? <Outlet /> : <Navigate to={locationTo} replace />;
};

export default UnprotectedRoute;
